var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 20.4964C6.4852 21.7112 3.0568 20.4964 1 16.7501",
    stroke: "#3D4351",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 22V18.596C10.6 17.9681 10.8208 17.4221 11.176 16.9286C11.4208 16.5905 11.2528 16.1097 10.8124 16.0047C7.16084 15.1248 4.60004 13.7126 4.60004 9.02759C4.60004 7.80962 5.05604 6.66515 5.85764 5.66767C6.05684 5.41988 6.15764 5.29598 6.18164 5.18468C6.20564 5.07129 6.16364 4.92534 6.07964 4.63135C5.74004 3.43858 5.76284 2.17126 6.27164 1.02994C6.27164 1.02994 7.32404 0.728598 9.72043 2.03791C10.2676 2.33716 10.5412 2.4873 10.7824 2.5209C11.0236 2.5545 11.3452 2.48415 11.9884 2.34346C12.9081 2.14396 13.8526 2.04555 14.8 2.05051C15.7475 2.04697 16.6918 2.14572 17.6116 2.34451C18.2548 2.4852 18.5776 2.5545 18.8188 2.52195C19.0588 2.48835 19.3324 2.33821 19.8796 2.03896C22.276 0.729649 23.3284 1.03099 23.3284 1.03099C23.8372 2.17231 23.86 3.43963 23.5204 4.6324C23.4364 4.92639 23.3956 5.07339 23.4196 5.18468C23.4436 5.29598 23.5432 5.42093 23.7424 5.66872C24.544 6.6662 25 7.81067 25 9.02864C25 13.7136 22.4392 15.1258 18.7876 16.0036C18.3472 16.1097 18.1792 16.5905 18.424 16.9276C18.7792 17.4211 19 17.9671 19 18.596V22",
    stroke: "#3D4351",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.20eb455a6c5097f3ec519c3b816759ab.svg";
export { ForwardRef as ReactComponent };